// Large centered play/pause icon shown over the Vimeo player while paused.
// Ported from helix-web's components/global/icons/CustomIcons/videoCarousel/Play.js
// (fill swapped for birch's --color-primary; helix's original used a
// helix-only "parlor-green" token that doesn't exist here). Always shown as
// a solid white circle with a green arrow — no hover state needed. (A
// green-circle/white-arrow variant was tried, but the arrow could vanish
// against darker parts of the video; white holds contrast consistently.)
const Play = () => (
  <svg
    className="h-[45px] w-[45px] cursor-pointer drop-shadow-[0_2px_12px_rgba(0,0,0,0.25)]"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m 18.001288,9.0012883 c 0,-4.9705601 -4.0294,-8.99999977 -8.9999991,-8.99999977 -4.9705605,0 -9.00000038,4.02943967 -9.00000038,8.99999977 0,4.9705977 4.02943988,8.9999977 9.00000038,8.9999977 4.9705991,0 8.9999991,-4.0294 8.9999991,-8.9999977 z"
      className="fill-white"
    />
    <path
      d="M 6.4434179,5.0012882 V 13.001286 L 13.110117,9.0012883 Z"
      className="fill-primary"
    />
  </svg>
);

export default Play;
